import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomAutocomplete from '../../atoms/CustomAutocomplete';
import { statusList } from '../../../../utils/checkStatus';
import { statusColorObj } from '../../../../themes';

const StatusSelect = ({ labelInside, info, value, handleChange }) => {
  const { t } = useTranslation();
  return (
    <CustomAutocomplete
      id="status-select"
      labelInside={labelInside}
      placeholder={labelInside ? t('molecules.status_select.text_input') : null}
      label={t('molecules.status_select.text_input')}
      info={info}
      required
      tags={statusList}
      selected={value}
      onSelectTags={handleChange}
      colorMap={statusColorObj}
    />
  );
};

StatusSelect.propTypes = {
  handleChange: PropTypes.func.isRequired,
  info: PropTypes.string,
  labelInside: PropTypes.bool,
  value: PropTypes.any,
};

export default StatusSelect;
